export enum ResourceStatus {
    Active = 1,
    Suspended = 0,
    NotDetermined = -1
}
